import {call, put, takeLatest} from "@redux-saga/core/effects";
import { errorAddQuote, errorEditQuote, errorQuoteById, errorQuotesList, QUOTES_ACTION, responseAddQuote, responseEditQuote, responseQuoteById, responseQuotesList } from "./QuoteActionCreator";
import QuoteService from "../../Services/RestApiManager/QuotesManager/QuoteService";

export function* quotesListRequest(action) {
    try {
        const response = yield call(QuoteService.shared.quotesListRequest, action.data);
        yield put(responseQuotesList(response));
    } catch (error) {
        yield put(errorQuotesList(error));
    }
    }

    export function* addQuotesRequest(action) {
        try {
            const response = yield call(QuoteService.shared.addQuotesRequest, action.data);
            yield put(responseAddQuote(response));
        } catch (error) {
            yield put(errorAddQuote(error));
        }
        }

        export function* editQuotesRequest(action) {
            try {
                const response = yield call(QuoteService.shared.editQuotesRequest, action.data);
                yield put(responseEditQuote(response));
            } catch (error) {
                yield put(errorEditQuote(error));
            }
            }
    
            export function* quoteByIdRequest(action) {
                try {
                  const response = yield call(QuoteService.shared.quoteByIdRequest, action.data);
                  yield put(responseQuoteById(response));
                } catch (error) {
                  yield put(errorQuoteById(error));
                }
              }

    export function* quotesWatcherSaga() {
        yield takeLatest(QUOTES_ACTION.REQUEST_QUOTES_LIST, quotesListRequest);
        yield takeLatest(QUOTES_ACTION.REQUEST_ADD_QUOTE, addQuotesRequest);
        yield takeLatest(QUOTES_ACTION.REQUEST_EDIT_QUOTE, editQuotesRequest);
        yield takeLatest(QUOTES_ACTION.REQUEST_QUOTE_BY_ID, quoteByIdRequest);
    }